var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "course-reminder-modal",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": !_vm.isMobile,
      "visible": !!_vm.coursesNotifications.length
    },
    on: {
      "hide": _vm.markViewedNotificationsAsRead
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_vm.coursesNotifications.length > 1 ? _c('div', {
    class: _vm.$style.buttons
  }, [_c('div', {
    on: {
      "click": _vm.goToPrevious
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.previousButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "orange"
    }
  }), _c('p', [_vm._v("Previous")])], 1), _c('div', {
    on: {
      "click": _vm.goToNext
    }
  }, [_c('p', [_vm._v("Next")]), _c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.nextButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "orange"
    }
  })], 1)]) : _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _c('div', {
    class: _vm.$style.headerContainer
  }, [_c('h2', [_vm._v(_vm._s(_vm.selectedCourseExtras.remindedBy) + " is requesting that you complete the following course in MottoLearn.")]), _c('p', [_vm._v("Please "), _c('u', {
    on: {
      "click": function ($event) {
        return _vm.launchApp(_vm.selectedCourseExtras);
      }
    }
  }, [_vm._v("launch")]), _vm._v(" the MottoLearn app below to complete this request")])]), _c('div', {
    class: _vm.$style.courseInfoContainer
  }, [_c('div', {
    class: _vm.$style.infoContainer
  }, [_c('div', {
    class: _vm.$style.thumbnailContainer
  }, [_c('div', [_c('img', {
    class: _vm.$style.courseThumbnail,
    attrs: {
      "src": _vm.selectedCourseExtras.thumbnail,
      "alt": "Course Thumbnail"
    }
  })]), _c('h3', [_vm._v(_vm._s(_vm.selectedCourseExtras.course_name))])]), _c('div', [_c('div', {
    class: _vm.$style.infoGroupContainer
  }, [_c('div', {
    class: _vm.$style.infoGroup
  }, [_c('strong', [_vm._v("Created By")]), _c('p', [_vm._v(_vm._s(_vm.selectedCourseExtras.course_creation_by_name))])]), _c('div', {
    class: _vm.$style.infoGroup
  }, [_c('strong', [_vm._v("Creation Date")]), _c('p', [_vm._v(_vm._s(_vm.courseCreationDate))])])]), _c('div', {
    class: _vm.$style.infoGroupContainer
  }, [_c('div', {
    class: _vm.$style.infoGroup
  }, [_c('strong', [_vm._v("Description")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedCourseExtras.description)
    }
  })])])])])]), _c('div', {
    class: _vm.$style.learnIcons
  }, [_c('div', [_c('MottoIcon', {
    attrs: {
      "name": "RocketColored"
    }
  }), _c('p', {
    staticClass: "color-secondary-light-blue cursor-pointer",
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function ($event) {
        return _vm.launchApp(_vm.selectedCourseExtras);
      }
    }
  }, [_vm._v("> Launch App")])], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }